<template>
  <div>
    <section class="section-filter">
      <div class="container">
        <div class="row filter-title">
          <div class="col-12">
            <div class="title-title2 secondary-color-txt">
              <span>
                <router-link :to="{ name: 'ViewNoticeAll' }" class="quay_lai secondary-color-txt">Thông báo</router-link>
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-content">
      <div class="container css-tabs">
        <h4 class="col-lg-12 font-size-22 font-sanpro-semibold primary_text_color mt-4 mb-3">Thông báo</h4>
        <div class="col-lg-4">
          <div class="form-group" style="position: relative;">
            <select
              class="custom-select"
              style="height:30px; line-height:18px;"
              @change="handelNotice"
              v-model="notice"
            >
              <option value="0">Phân loại thông báo - tất cả</option>
              <option
                v-for="(option,index) in getAllNotice.list"
                :key="index"
                :value="option.notificationTypeId"
              >{{ option.name }}</option>
            </select>
            <i
              class="fa fa-angle-down primary-color font-size-16"
              style="position: absolute; top: 8px; right: 2%;"
            ></i>
          </div>
        </div>
        <div class="col-lg-12 table-list mt-4" v-if="listDataNotication && listDataNotication.length >0">
          <div
            class="justify-content-between display-flex border-bottom-noticeall notify-mobile cursor-pointer"
            :class="{'background-isRead':!item.isRead}"
            v-for="(item,index) of listDataNotication"
            :key="index"
            @click="showInfoNoti(item, index)"
          >
            <div  
            class=" display-flex-center">
              <!-- <img
                :src="item.avatar != null ? appUrl + item.avatar : thumbUrl('HS-2.jpg')"
                class="border-rd-50"
              />-->
              <span class="icon-list mr-4 ml-2"></span>
              <span>
                  <b class="primary-color-txt font-sanpro-semibold">{{ item.notificationName }}</b>
                  <br />
                  {{ item.title }}
                  <br />
                  <span v-html="item.message "></span>
              </span>
            </div>
            <div class="display-flex-center time-tool">
              <span
                
                class="secondary_text_color font-size-16"
              >{{ moment(item.createAt).format('hh:mm - DD/MM/YYYY') }}</span>

              <div class="btn-del">
                <div class="dropdown dropdown-account">
                  <button
                    class="dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="fas fa-ellipsis-h"></i>
                  </button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <a
                      @click="deleteNotication(item.notificationId)"
                      class="dropdown-item four-color"
                      href="javascript:;"
                    >Xóa thông báo</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <p class="col-12 text-center pagiination-training mb-4 mt-4 display-inline">
            <Pagination @eventPagination="getTrainingPagination" :totalPage="totalPage" />
          </p>  -->
        </div>

        <h2 class="text-center full-width secondary-color-txt" v-else>Chưa có thông báo nào.</h2>
        <div id="myDiv" ref="myDiv"></div>
        <div id="myDiv2" ref="myDiv2"></div>
        <ModalNotiDetail />
        <!-- <modalNotify /> -->
      </div>
    </section>
  </div>
</template>
<script>
import { ID_MODAL_NOTIFY } from '@/store/common/constants'
import { mapActions, mapGetters,mapState } from "vuex";
import { STORE_KEY } from "../_store/constants";
import { MODAL_ID_REQ_INFO_DETAIL } from "@/store/common/constants";
import { readNotification } from "@/store/common/api";
import ModalNotiDetail from "./../../../components/modal/ModalNotiDetail";
import modalNotify from "./../../../components/modal/modalNotify"
import Pagination from "@/components/Pagination.vue";
import {
  apiNotificationListNotificationType,
  apiGetListNotication,
  apiDeleteNotication,
} from "../_api";
import { APP_CONFIG } from "@/utils/constants";
import moment from "moment";
export default {
  components: {
    ModalNotiDetail,
    Pagination,
    modalNotify
  },
  data() {
    return {
      elmEndItem: null,
      totalPage: 0,
      appUrl: APP_CONFIG.appUrl,
      listDataNotication: [],
      getAllNotice: [
        { name: "Phân loại thông-báo tất cả", id: 1 },
        { name: "Phân loại thông-báo tất cả", id: 2 },
      ],
      notice: 0,
      notificationSingle: {},
      pagingData:{},
    };
  },
  computed: {
    ...mapGetters({
      getParamlistNotification: STORE_KEY + "/getParamlistNotification",
    }),
     ...mapState("common", [ "getPramDisplay", "isShowModalNotify"]),
  },
  mounted() {
    

    this.elmEndItem = document.getElementById('myDiv')
    // this.elmEndItem2 = document.getElementById('myDiv2')

    // console.log('123', this.elmEndItem);
    if (this.elmEndItem) {
        this.observer = new IntersectionObserver(this.handleScrollEnd, {threshold: 1})
        this.observer.observe(this.elmEndItem)
    }

    this.setParamListNotication({
      ...this.paramlistNotification,
      notificationTypeId: 0,
      keyword: "",
      pageIndex: 1,
      pageSize: 10,
      sort: "",
      direction: "",
    });
    apiNotificationListNotificationType().then((res) => {
      this.getAllNotice = res.data.data;
    });
  },
  watch: {
    getParamlistNotification: "changeParamlistNotification",
    pagingData(newVal) {
      // console.log("222222222222222222222222222 newVal",newVal);
    },
    isShowModalNotify(newVal){
      if(newVal){
       this.$bvModal.show(ID_MODAL_NOTIFY)
      }
    }
  },
  methods: {
    ...mapActions(`${STORE_KEY}`, ["setParamListNotication"]),
    // ...mapActions(`common`, ["setLoading"]),
    ...mapActions(`common`, [
      "setLoading",
      "setDataDetailNotifi",
      "actionDisplayNotification",
      "acToggleModalShowNotify",
      "actionCountNotificationNotRead",
      "actionSetDataModalNoti"
    ]),
    moment,
    thumbUrl(filename) {
      return require(`@/assets/img/${filename}`);
    },
    showInfoNoti(val, index) {
      let self = this;
      if(val.isAuto === false){
        this.acToggleModalShowNotify(true)
        this.actionSetDataModalNoti(val)
      }
      if(val.url && val.url !== null && val.isAuto){
          let routeName = val.url.replace(`${window.location.origin}`,"")
          // console.log("routeName",routeName);
          if(this.$route.path.toString() !=routeName.toString()){
            self.$router.push({ path: `${routeName}`})
          }
      }
      if (val && val.notificationId && !val.isReaded) {
        self.setLoading(true);
        readNotification(val.notificationId)
          .then((res) => {
            // console.log("set res", res);
            if (res && !res.errors) {
              // self.notificationData[index]["isReaded"] = true;
            }
            self.setDataDetailNotifi(val);
            apiGetListNotication({...this.getParamlistNotification, pageIndex: 1, pageSize: 99}).then((res) => {
              this.listDataNotication = res.data.list;
              this.pagingData = res.data.paging;
              this.handleScrollEnd()
              // let values = true;
              this.actionCountNotificationNotRead(!this.getPramDisplay)
            });
          })
          .finally(() => self.setLoading(false));
      }
    },
    handelNotice() {
      this.setParamListNotication({
        ...this.getParamlistNotification,
        notificationTypeId: this.notice,
        pageIndex: 1,
        pageSize: 20
      });
      // console.log('this.pagingData.pageIndex', this.pagingData.pageIndex)
    },
    deleteNotication(id) {
      let values = {};
      values.id = id;
      apiDeleteNotication(values).then((res) => {
        this.$toast.success("Xóa thành công");
        this.actionDisplayNotification(values);
        apiGetListNotication(this.getParamlistNotification).then((res) => {
          this.listDataNotication = res.data.list;
          this.pagingData = res.data.paging;
        });
      });
    },
    changeParamlistNotification() {
      this.setLoading(true);
      apiGetListNotication(this.getParamlistNotification).then(res=>{
          this.listDataNotication  = this.getParamlistNotification.pageIndex === 1 ? res.data.list : [...this.listDataNotication, ...res.data.list];
          this.pagingData  = res.data.paging

      })
      .finally(() => {
          this.setLoading(false);
      });

    },
    getTrainingPagination(value) {
      this.setParamListNotication({
        ...this.getParamlistNotification,
        pageIndex: value,
      }).finally(() => {
        // this.setLoading(false);
      });
    },
    handleScrollEnd(){
        // if( this.pagingData && this.pagingData.totalPage && this.getParamlistNotification.pageIndex < this.pagingData.totalPage){
        if(this.pagingData && this.pagingData.totalPage && this.getParamlistNotification.pageIndex < this.pagingData.totalPage){
          this.setParamListNotication({...this.getParamlistNotification, pageIndex: this.getParamlistNotification.pageIndex + 1})
        } 
        // }
    },
  },
};
</script>
<style lang="scss" scoped>
.table-list {
  margin-bottom: 20px;
  margin-top: 40px;
}
.dropdown-item {
  margin-top: 7px !important;
}
.dropdown-menu {
  padding: 0 0 0.5rem;
  margin: 0.125rem 0 0;
  -webkit-transform: translate3d(-115px, 30px, 0) !important;
  transform: translate3d(-121px, 30px, 0) !important;
}
.dropdown-account {
  button {
    color: #879aa9;
    font-size: 14px;
    text-align: left;
    border: 0;
    padding-left: 15px;
    border-radius: 30px;
    outline: 0;
    background: none !important;
  }
  .dropdown-toggle::after {
    display: inline-block;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
    display: none;
  }
}
// .dropdown-account button, .dropdown-training button {
//     color: #879aa9;
//     font-size: 14px;
//     text-align: left;
//     border: 0;
//     padding-left: 15px;
//     border-radius: 30px;
//     outline: 0;
// }
.dropdown-toggle {
  outline: 0;
}
.custom-select {
  border: none !important;
  border-radius: 20px !important;
  height: 30px;
  background: #f3f6fb !important;
  font-size: 15px !important;
  height: 30px !important;
  padding-top: 0;
  padding-bottom: 0;
}
.css-tabs {
  padding: 0 75px;
}
.dropdown-toggle {
  outline: 0;
}
.background-isRead {
  background: #E1EFFF;
}
.border-bottom-noticeall {
  border-bottom: 1px solid #f1f1f1;
  padding: 20px 5px;
  img {
    width: 30px;
    height: 30px;
    margin-right: 15px;
  }
  &:hover {
    // background: #e1efff;
  }
}
@media screen and (max-width:768px){
  .css-tabs {
    padding: 0 25px;
  }
  .notify-mobile{
    position: relative;
    display: block;
  }
  .time-tool{
    margin-left: 49px;
  }
  .btn-del{
    position: absolute;
    top: 5px;
    right: 10px;
  }
}
</style>